const env = process.env.REACT_APP_ENV;
console.log("===>ENV NEW", env);
export const API_BASE_URL =
  env === "production"
    ? "https://hello-gorgeous.shop/api/v1"
    : "https://dev.hello-gorgeous.shop/api/v1";

export const EMAIL_REGEX =
  /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;

export const PHONE_NUMBER_REGEX =
  /^(\+?\d{1,3})?[-.\s]?(\(?\d{1,4}\)?)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;

export const FILE_SIZE_MAX_LIMIT = 2 * 1024 * 1024;

export const IMAGE_INPUT_CLASS = `block h-[58px] w-full rounded-r-lg text-sm text-slate-500
file:mr-4 file:rounded-full file:border-0
file:bg-violet-50 file:py-1 file:px-4 file:text-sm
file:font-semibold file:text-violet-700 hover:file:bg-violet-100`;

export const GENDER_OPTIONS = [
  { value: "", label: "Select Gender" },
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
];

export const SELECTED_VIEW = {
  GRID: "grid",
  TILES: "tiles",
};

export const ASSETS_LOCATION =
  env === "production"
    ? "https://hello-gorgeous.shop/public/uploads/"
    : "https://dev.hello-gorgeous.shop/public/uploads/";
